import React, { useState, useEffect, useContext } from 'react';

import { Box, IconButton, Paper, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, Stack, TextField, InputAdornment } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { isEmpty } from 'lodash';
import { DataContext } from '../../../context/DataContext';
import { simpleMessage } from '../../../helpers/Helpers';
import { getToken } from '../../../api/Account';
import NoData from '../../../components/NoData';
import { PaginationComponent } from '../../../components/PaginationComponent';
import { getListTipoCambioAsync } from '../../../api/TipoCambio';
import moment from 'moment/moment';

import SmallModal from '../../../components/modals/SmallModal';
import AddValorCompra from './AddValorCompra';
import { monoFont } from '../../../theme';

const money = (n) => new Intl.NumberFormat('es-NI', { style: 'currency', currency: 'NIO' }).format(n);

const TasaCambioList = () => {
	const [tasaCambioList, setTasaCambioList] = useState([]);
	const [selectedTC, setSelectedTC] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [localReload, setSetLocalReload] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');

	const withSearch = tasaCambioList.filter((item) => !searchTerm.trim() || moment(item.fecha).format('DD/MM/YYYY').includes(searchTerm.trim()));
	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getListTipoCambioAsync(token);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}

			setIsLoading(false);
			setTasaCambioList(result.data);
		})();
	}, []);

	const [currentPage, setCurrentPage] = useState(1);
	const [itemsperPage] = useState(10);
	const indexLast = currentPage * itemsperPage;
	const indexFirst = indexLast - itemsperPage;
	const currentItem = withSearch.slice(indexFirst, indexLast);
	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const onChangeSearch = (val) => {
		setCurrentPage(1);
		setSearchTerm(val);
		paginate(1);
	};

	const editTC = (val) => {
		setSelectedTC(val);
		setShowModal(true);
	};

	return (
		<div>
			<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', sm: 'center' }} spacing={1.5} sx={{ marginBottom: '18px' }}>
				<TextField
					size="small"
					onChange={(e) => onChangeSearch(e.target.value.toUpperCase())}
					value={searchTerm}
					placeholder="Buscar por fecha..."
					sx={{ width: { xs: '100%', sm: 260 } }}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<SearchRoundedIcon sx={{ fontSize: 19, color: 'text.disabled' }} />
							</InputAdornment>
						)
					}}
				/>
			</Stack>

			{isEmpty(currentItem) ? (
				<NoData />
			) : (
				<Paper sx={{ overflow: 'hidden' }}>
					<TableContainer sx={{ overflowX: 'auto' }}>
						<Table size="small" sx={{ minWidth: 560 }}>
							<TableHead>
								<TableRow>
									<TableCell>#</TableCell>
									<TableCell>Fecha</TableCell>
									<TableCell align="right">BCN</TableCell>
									<TableCell align="right">Compra</TableCell>
									<TableCell align="center">Editar</TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{currentItem.map((row) => {
									const { id, fecha, dolar, compra } = row;
									return (
										<TableRow key={id}>
											<TableCell sx={{ fontFamily: monoFont, color: 'text.disabled' }}>{id}</TableCell>
											<TableCell sx={{ fontFamily: monoFont, fontSize: 12.5 }}>{moment(fecha).format('L')}</TableCell>
											<TableCell align="right" sx={{ fontFamily: monoFont }}>
												{money(dolar)}
											</TableCell>
											<TableCell align="right" sx={{ fontFamily: monoFont, fontWeight: 600 }}>
												{money(compra)}
											</TableCell>

											<TableCell align="center">
												<IconButton size="small" onClick={() => editTC(row)}>
													<EditRoundedIcon sx={{ fontSize: 17 }} />
												</IconButton>
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
					<Box sx={{ padding: '10px 20px 14px' }}>
						<PaginationComponent data={withSearch} paginate={paginate} itemsperPage={itemsperPage} />
					</Box>
				</Paper>
			)}

			<SmallModal titulo={'Agregar valor de compra'} isVisible={showModal} setVisible={setShowModal}>
				<AddValorCompra localReload={localReload} setLocalReload={setSetLocalReload} setShowModal={setShowModal} selectedTC={selectedTC} />
			</SmallModal>
		</div>
	);
};

export default TasaCambioList;
